import clsx from 'clsx';
import camelCase from 'just-camel-case';
import capitalize from 'just-capitalize';

import { translateProperty, resolveProperties } from './utils';

import type { FagmoblerPublicOmniumProduct } from '@fagmobler/types';

type propertyKey = FagmoblerPublicOmniumProduct['properties'][0]['key'];

export type SizePropertiesProps = {
  product?: FagmoblerPublicOmniumProduct;
  allowedProperties?: propertyKey[];
  disallowedProperties?: propertyKey[];
};

export function SizeProperties({
  product,
  allowedProperties = [
    'depth',
    'depth2',
    'width',
    'height',
    'weight',
    'length',
    'seatDepth',
    'seatHeight',
  ],
  disallowedProperties = [],
}: SizePropertiesProps) {
  if (!product) return null;

  const properties = resolveProperties(
    product,
    allowedProperties,
    disallowedProperties
  );

  return (
    <ul className={clsx('print:flex')}>
      {properties.map(({ key, value }) => {
        const property = translateProperty(camelCase(key));

        return (
          <li
            key={key}
            className={clsx(
              'text-left',
              'cap-xs',
              'pr-5 pb-1',
              'font-normal',
              'print:cap-sm',
              'print:font-semibold'
            )}
          >
            <span className={clsx('mr-2 print:block print:body-xs')}>
              {capitalize(property.text)}
            </span>
            {value} {property.postfix ?? ''}
          </li>
        );
      })}
    </ul>
  );
}

export default SizeProperties;
